<div class="modal-header" medptevlog>
  <h4 class="modal-title" id="modal-title">Copy to RegDoc eSafe®</h4>
  <span type="button" class="btn-close" *ngIf="isBinderSelection" (click)="modal.dismiss('')" medpt-log-action="CloseModel" medpt-log-message="Close Model Copy to RegDoc eSafe®"></span>
  <span type="button" class="btn-close" *ngIf="!isBinderSelection" (click)="SuccessMessage != '' ? modal.dismiss('') : SaveLeadData('No',true);" medpt-log-action="CloseModel" medpt-log-message="Close Model Copy to RegDoc eSafe®"></span>
</div>
<div class="modal-body" medptevlog>
  <div *ngIf="SuccessMessage != ''">
    <div class="row">
      <div class="col col-12" style="font-size: .875em;">
        <h5><span style="color:green;">{{SuccessMessage}}</span></h5>
        <h5 *ngIf="IncludeLearnMore">To learn more about RegDoc eSafe, <a href="javascript:void(0);" (click)="SaveLeadData('Yes',true)">Click here</a></h5>
      </div>
    </div>
  </div>
  <div *ngIf="SuccessMessage == ''">
    <div class="row" *ngIf="!loading && !isBinderSelection">
      <form class="form-horizontal" [formGroup]="contactmeform" (ngSubmit)="contactMe()" id="contactmeform">
        <div class="col col-12 mb-2">
          <div class="d-flex">
            <div class="icon-attention me-3 mt-4" style="color: #F39C12;font-size: 44px;"></div>
            <div>
              <div>
                <p>RegDoc eSafe, an electronic Regulatory Document binder, is available at no cost for this study and other studies.</p>
                <p>Either you or your site is not currently set up to copy documents into RegDoc eSafe. Set up is fast and easy. Please click "CONTACT ME" and one of our team members will assist you.</p>
                <p>To learn more about RegDoc eSafe, <a href="javascript:void(0);" (click)="SaveLeadData('Yes',false);">Click here</a></p>
              </div>
              <div>
                <div class="col col-6">
                  <div class="col col-12 mb-2 p-0">
                    <label class="col-form-label">Your Name (required)</label>
                    <input type="text" placeholder="Your Name" formControlName="name" [ngClass]="{'is-invalid': contactmeform.controls['name'].invalid && (contactmeform.controls['name'].touched || submitted)}" />
                    <span class="text-danger small" *ngIf="(contactmeform.controls['name'].touched || submitted) && contactmeform.controls['name'].errors?.['required']">Name is required</span>
                  </div>
                  <div class="col col-12 mb-2 p-0">
                    <label class="col-form-label">Your Email (required)</label>
                    <input type="text" placeholder="Your Email" formControlName="email" [ngClass]="{'is-invalid': contactmeform.controls['email'].invalid && (contactmeform.controls['email'].touched || submitted)}" />
                    <span class="text-danger small" *ngIf="(contactmeform.controls['email'].touched || submitted) && contactmeform.controls['email'].errors?.['required']">Email is required</span>
                    <small class="text-danger small" *ngIf="contactmeform.controls['email'].errors?.['pattern']">Please provide a valid email address</small>
                  </div>
                  <div class="col col-12 mb-2 p-0">
                    <label class="col-form-label">Company Name (required)</label>
                    <input type="text" placeholder="Your Company Name" formControlName="company" [ngClass]="{'is-invalid': contactmeform.controls['company'].invalid && (contactmeform.controls['company'].touched || submitted)}" />
                    <span class="text-danger small" *ngIf="(contactmeform.controls['company'].touched || submitted) && contactmeform.controls['company'].errors?.['required']">Company name is required</span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </form>
    </div>
    <div class="row" *ngIf="!loading && isBinderSelection">
      <form class="form-horizontal" [formGroup]="movedocumentform" (ngSubmit)="moveDocument()" id="movedocumentform">
        <div class="col col-12 mb-2" *ngIf="hasError">
          <label class="col-form-label text-danger">Failed to copy document</label>
        </div>
        <div class="col col-12 mb-2">
          <label class="col-form-label">Site</label>
          <mat-select placeholder="Select site" (selectionChange)="onSiteChange()" formControlName="site" [ngClass]="{'is-invalid': movedocumentform.controls['site'].invalid && (movedocumentform.controls['site'].touched || submitted)}">
            <mat-option>Select site</mat-option>
            <mat-option *ngFor="let status of sitesList" [value]="status.SiteGuid">{{status.SiteName}}</mat-option>
          </mat-select>
          <span class="text-danger small" *ngIf="(movedocumentform.controls['site'].touched || submitted) && movedocumentform.controls['site'].errors?.['required']">Site is required</span>
        </div>
        <div class="col col-12 mb-2">
          <label class="col-form-label">Binder</label>
          <mat-select placeholder="Select binder" formControlName="binder" [ngClass]="{'is-invalid': movedocumentform.controls['binder'].invalid && (movedocumentform.controls['binder'].touched || submitted)}">
            <mat-option>Select binder</mat-option>
            <mat-option *ngFor="let status of filteredBinderList" [value]="status.BinderGuid">{{status.BinderName}}</mat-option>
          </mat-select>
          <span class="text-danger small" *ngIf="(movedocumentform.controls['binder'].touched || submitted) && movedocumentform.controls['binder'].errors?.['required']">Binder is required</span>
        </div>
        <div class="col col-12 mb-2">
          <mat-checkbox (change)="onDontSeeMySiteBinderChange()" >Don't see my site or binder</mat-checkbox>
        </div>
      </form>
    </div>
  </div>
</div>
<div class="modal-footer" *ngIf="SuccessMessage == ''" medptevlog>
  <button type="button" class="secondaryBtn" *ngIf="isBinderSelection" (click)="modal.dismiss('')" medpt-log-action="CloseModel" medpt-log-message="Close Model Copy to RegDoc eSafe®">Cancel</button>
  <button type="button" class="secondaryBtn" *ngIf="!isBinderSelection" (click)="SuccessMessage != '' ? modal.dismiss('') : SaveLeadData('No',true);" medpt-log-action="CloseModel" medpt-log-message="Close Model Copy to RegDoc eSafe®">Cancel</button>

  <button type="submit" class="primaryBtn" form="movedocumentform" *ngIf="isBinderSelection" ngbAutofocus medpt-log-action="Click" [attr.medpt-log-message]="'Move the ' + placeIneRegBinder.DocumentType + ' to eSafe'">Copy</button>
  <button type="submit" class="primaryBtn" form="contactmeform" *ngIf="!isBinderSelection" ngbAutofocus medpt-log-action="Click" medpt-log-message="Contact me">Contact me</button>
</div>
